import { Injectable } from '@angular/core';
import { IdampHttpClient } from '../common/IdampHttpClient';
import { Observable, from } from 'rxjs';
import { IIdmApplication } from 'src/app/models/idm/applications/IdmApplication';
import { IGenericApiResponse } from 'src/app/models/common/GenericApiResponse';
import { IGraphApplication } from 'src/app/models/graph/applications/GraphApplication';

@Injectable({
  providedIn: 'root'
})
export class ChevronApplicationService {

  constructor(private http: IdampHttpClient) { }

  public SearchApplication(term: string, includeEnvironments: boolean = false, includeApplicationOwners: boolean = false): Observable<IGenericApiResponse<IIdmApplication[]>> {
    const path = `chevronApplications`;
    const query = {
      searchTerm: term, filterActive: true,
      includeEnvironmentsInfo: includeEnvironments,
      includeApplicationOwners: includeApplicationOwners
    };
    return from(this.http.GetAsync<IGenericApiResponse<IIdmApplication[]>>(path, query));
  }

  public GetApplication(id: string, includeEnvironments: boolean = false): Observable<IGenericApiResponse<IIdmApplication>> {
    return from(this.GetApplicationAsync(id, includeEnvironments));
  }
  public async GetApplicationAsync(id: string, includeEnvironments: boolean = false): Promise<IGenericApiResponse<IIdmApplication>> {
    const path = `chevronApplications/${id}`;
    const query = {
      includeEnvironments: includeEnvironments
    };
    return await this.http.GetAsync<IGenericApiResponse<IIdmApplication>>(path, query);
  }

  public GetAssociatedKeyvaultNames(id: string): Observable<IGenericApiResponse<string[]>> {
    return from(this.GetAssociatedKeyvaultNamesAsync(id));
  }
  public async GetAssociatedKeyvaultNamesAsync(id: string): Promise<IGenericApiResponse<string[]>> {
    const path = `chevronApplications/${id}/keyvaults`;
    const query = {};
    return await this.http.GetAsync<IGenericApiResponse<string[]>>(path, query);
  }

  public GetOwnedUserAssignedManagedIdentities(): Observable<IGenericApiResponse<IGraphApplication[]>> {
    return from(this.GetOwnedUserAssignedManagedIdentitiesAsync());
  }
  public async GetOwnedUserAssignedManagedIdentitiesAsync(): Promise<IGenericApiResponse<IGraphApplication[]>> {
    const path = `me/ownedObjects/UserAssignedManagedIdentities`;
    const query = {};
    return await this.http.GetAsync<IGenericApiResponse<IGraphApplication[]>>(path, query);
  }
}
